export default __webpack_public_path__ + "static/media/WeatherAppPhone.7629818e.png";